<template>
  <div class="template6">
    <!-- 主内容区 -->
    <div class="t6-content">
      <!-- 顶部推荐图 -->
      <div class="t6-top-banner">
        <img src="/static/image/event/2035233566223306753_00.avif" class="top-banner-img" alt="" />
      </div>

      <!-- 活动详情+表格整体区块 -->
      <div class="t6-card">
        <!-- 活动详情 -->
        <div v-if="activityData.content">
          <div class="t6-card-title">活动详情</div>
          <div class="t6-text" v-html="activityData.content"></div>
        </div>

        <!-- 表格 -->
        <div class="t6-table-wrap" v-if="activityData.special1">
          <table class="t6-table">
            <thead>
              <tr>
                <th v-for="(col, ci) in activityData.special1.columns" :key="ci">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, ri) in activityData.special1.rows" :key="ri">
                <td v-if="ri === 0" :rowspan="activityData.special1.rows.length" class="merge-cell">{{ row[0] }}</td>
                <td v-if="ri === 0" :rowspan="activityData.special1.rows.length" class="merge-cell">{{ row[1] }}</td>
                <td v-if="ri === 0" :rowspan="activityData.special1.rows.length" class="merge-cell">{{ row[2] }}</td>
              </tr>
            </tbody>
          </table>
          <div class="t6-table-note" v-if="activityData.special1.note" v-html="activityData.special1.note"></div>
        </div>
      </div>

      <!-- 参与条件卡片 -->
      <div class="t6-card t6-card-inline" v-if="activityData.conditions">
        <div class="t6-card-title">参与条件</div>
        <div class="t6-text" v-html="activityData.conditions"></div>
      </div>

      <!-- 领取方式卡片 -->
      <div class="t6-card t6-card-inline" v-if="activityData.receiveMethod">
        <div class="t6-card-title">领取方式</div>
        <div class="t6-text" v-html="activityData.receiveMethod"></div>
      </div>

      <!-- 活动说明/规则卡片 -->
      <div class="t6-card" v-if="activityData.memo">
        <div class="t6-card-title">活动规则</div>
        <div class="t6-rules">
          <template v-if="Array.isArray(activityData.memo)">
            <p v-for="(item, index) in activityData.memo" :key="index">{{ item }}</p>
          </template>
          <template v-else>
            <div v-html="activityData.memo"></div>
          </template>
        </div>
      </div>

      <!-- 活动图片 -->
      <div class="t6-activity-img" v-if="activityData.special1Img">
        <img :src="activityData.special1Img" class="t6-activity-img-inner" alt="" />
      </div>

      <!-- 底部推荐图横向滑动 -->
      <div class="t6-recommend" v-if="recommendList.length > 0" ref="recommendWrap">
        <div class="t6-recommend-inner" ref="recommendInner">
          <div
            v-for="(item, index) in recommendList"
            :key="index"
            class="t6-recommend-item"
            :ref="'recItem' + index"
            :class="{ 't6-recommend-active': item.activityId === String(activityData.id) }"
            @click="goRecommend(item)"
          >
            <img :src="item.image" class="t6-recommend-img" alt="" />
            <div class="t6-recommend-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="t6-footer" v-if="showFooter">
      <div class="t6-footer-info">
        <span>剩余申请次数：{{ applyCount }}</span>
        <span class="t6-refresh" @click="handleRefresh"> 刷新次数</span>
      </div>
      <div class="t6-footer-btns">
        <button class="t6-btn t6-btn-back" @click="$router.back()">返回</button>
        <button class="t6-btn t6-btn-apply" @click="handleApply">优惠申请</button>
      </div>
    </div>

    <!-- 弹框 -->
    <div class="popup-overlay" v-if="showPopup" @click.self="closePopup">
      <div class="popup-content">
        <div class="popup-close" @click="closePopup">
          <img src="/static/image/event/close_popup.png" alt="关闭" />
        </div>
        <div class="popup-body">
          <img :src="popupItem.image" class="popup-img" alt="" />
          <div class="popup-name">{{ popupItem.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { recommendList } from './activityConfig';

export default {
  name: 'template6',
  props: {
    activityData: {
      type: Object,
      default: () => ({}),
    },
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      applyCount: 0,
      showPopup: false,
      popupItem: null,
      recommendList,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  computed: {
    currentActivityConfig() {
      const id = String(this.activityData.id);
      return this.recommendList.find(item => item.activityId === id) || {};
    },
    showFooter() {
      return this.currentActivityConfig.apply_show === 1;
    },
  },
  methods: {
    handleRefresh() {},
    handleApply() {
      if (!this.$store.state.token) {
        this.$parent.showTost(0, '请先登录');
        return;
      }
      this.$parent.showLoading();
      this.$apiFun.post('/api/doactivityapply', { activityid: this.activityData.id }).then(res => {
        this.$parent.hideLoading();
        this.$parent.showTost(res.code === 200 ? 1 : 0, res.message);
        if (res.code === 200 && res.data) {
          this.applyCount = res.data.remaining || 0;
        }
      }).catch(() => {
        this.$parent.hideLoading();
      });
    },
    goRecommend(item) {
      if (item.popup === 1) {
        this.popupItem = item;
        this.showPopup = true;
      } else if (item.url_open === 1 && item.url) {
        window.location.href = item.url;
      } else if (item.jump) {
        this.$router.replace(`/activityDetail?template=${item.templateId}&activity_id=${item.activityId}&from=${this.from}`).catch(() => {});
      }
    },
    closePopup() {
      this.showPopup = false;
      this.popupItem = null;
    },
    scrollToActive() {
      const activeIndex = this.recommendList.findIndex(item => item.activityId === String(this.activityData.id));
      if (activeIndex === -1) return;

      const wrap = this.$refs.recommendWrap;
      const items = this.$refs['recItem' + activeIndex];
      if (!wrap || !items || !items[0]) return;

      const itemEl = items[0];
      const wrapWidth = wrap.offsetWidth;
      const itemLeft = itemEl.offsetLeft;
      const itemWidth = itemEl.offsetWidth;

      // 计算滚动位置：让选中项居中
      const scrollLeft = itemLeft - (wrapWidth / 2) + (itemWidth / 2);
      wrap.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
.template6 {
  padding-bottom: 1.2rem;
  background: #0a0a0a;
  min-height: 100vh;
}

.t6-content {
  padding: 0.2rem;
  margin-bottom: 0;
}

.t6-top-banner {
  margin-bottom: 0;
  background: #0a0a0a;
  border-radius: 0.15rem;
  overflow: hidden;
  padding: 0.2rem;

  .top-banner-img {
    width: 100%;
    display: block;
  }
}

.t6-card {
  background: #0a0a0a;
  border-radius: 0.15rem;
  padding: 0.3rem;

  .t6-card-title {
    font-size: 0.3rem;
    color: #e7c356;
    font-weight: 600;
    text-align: left;
    margin-bottom: 0.15rem;
  }

  &.t6-card-inline {
    display: flex;
    align-items: center;
    padding: 0.15rem 0.3rem;

    .t6-card-title {
      flex-shrink: 0;
      margin-bottom: 0;
      margin-right: 0.05rem;
    }

    .t6-text {
      flex: 1;
    }
  }

  .t6-text {
    font-size: 0.28rem;
    color: #fff;
    line-height: 1.6;
    text-align: left;
    width: 100%;
    font-weight: 600;
  }
}

// 表格区块
.t6-table-wrap {
  margin-bottom: 0.1rem;
  margin-top: 0.3rem;
}

.t6-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.28rem;

  thead th {
    background: #0a0a0a;
    color: #e7c356;
    padding: 0.15rem 0.1rem;
    text-align: center;
    font-weight: 600;
    font-size: 0.28rem;
    border: 1px solid #f1c40f;
  }

  tbody td {
    padding: 0.12rem 0.1rem;
    text-align: center;
    color: #fff;
    font-size: 0.28rem;
    font-weight: 600;
    border: 1px solid #f1c40f;
  }

  .merge-cell {
    writing-mode: horizontal-tb;
    text-align: center;
    line-height: 1.6;
    white-space: pre-line;
    font-weight: 600;
  }
}

.t6-table-note {
  font-size: 0.28rem;
  color: #fff;
  margin-top: 0.15rem;
  line-height: 1.6;
  font-weight: 600;
}

// 活动图片
.t6-activity-img {
  margin-top: 0.3rem;
  border-radius: 0.15rem;
  overflow: hidden;

  .t6-activity-img-inner {
    width: 100%;
    display: block;
  }
}

// 底部推荐图
.t6-recommend {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 0.2rem;

  .t6-recommend-inner {
    display: flex;
    gap: 0.15rem;
    width: max-content;
    margin-top: 1rem;
  }

  .t6-recommend-item {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: thin solid transparent;
    border-radius: 0.1rem;
    box-sizing: border-box;

    &.t6-recommend-active {
      border: thin solid #d1ae52;
    }
  }

  .t6-recommend-img {
    width: 2.5rem;
    border-radius: 0.1rem;
    flex-shrink: 0;
    object-fit: cover;
  }

  .t6-recommend-name {
    width: 2.5rem;
    font-size: 0.24rem;
    color: #ccc;
    text-align: center;
    margin-top: 0.1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.t6-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #0a0a0a;
  padding: 0.25rem 0.2rem 0.5rem;
  box-sizing: border-box;
  z-index: 100;

  .t6-footer-info {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.2rem;
    font-size: 0.26rem;
    color: #888;
    margin-bottom: 0.25rem;

    .t6-refresh {
      color: #DFB372;
    }
  }

  .t6-footer-btns {
    display: flex;
    gap: 0.2rem;

    .t6-btn {
      flex: 1;
      height: 0.85rem;
      line-height: 0.85rem;
      border: none;
      border-radius: 0.4rem;
      font-size: 0.32rem;
      font-weight: 600;
      text-align: center;
    }

    .t6-btn-back {
      background: transparent;
      border: 1px solid #DFB372;
      color: #DFB372;
    }

    .t6-btn-apply {
      background: #898989;
      color: #fff;
    }
  }
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  .popup-content {
    position: relative;
    width: 80%;
    max-width: 3rem;
    background: #0a0a0a;
    border-radius: 0.1rem;
    padding: 0.2rem;
  }

  .popup-close {
    position: absolute;
    top: -0.4rem;
    right: -0.4rem;
    width: 0.4rem;
    height: 0.4rem;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .popup-body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .popup-img {
    width: 100%;
    border-radius: 0.1rem;
    margin-bottom: 0.1rem;
  }

  .popup-name {
    font-size: 0.28rem;
    color: #fff;
    text-align: center;
  }
}
</style>

<style>
.t6-rules {
  font-size: 0.28rem !important;
  color: #fff !important;
  line-height: 1.6 !important;
  width: 100% !important;
  margin: 0;
  padding: 0;
}
.t6-rules p {
  margin: 0 0 0.1rem 0;
  padding: 0;
}
.t6-rules strong {
  color: #fff !important;
  font-weight: 600;
}
.t6-rules .blue-text {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/activityDetail/template6.vue